/* Solli's Newsletter-Popup, Skript zur Sektion sections/sollis-anmeldung.liquid.
   Liest seine Einstellungen aus den data-Attributen von #sanm. Laeuft auch nach dem Neuladen der Sektion im Theme-Editor. */
(function () {
  function init() {
    var root = document.getElementById('sanm');
    if (!root || root.getAttribute('data-sanm-an') === '1') return;
    root.setAttribute('data-sanm-an', '1');
    var d = root.dataset;
    var ov = root.querySelector('.sanm__ov');
    var dlg = root.querySelector('.sanm__dlg');
    var formteil = root.querySelector('[data-sanm-formteil]');
    var form = root.querySelector('[data-sanm-form]');
    var msg = root.querySelector('[data-sanm-msg]');
    var erfolg = root.querySelector('[data-sanm-erfolg]');
    var teaser = root.querySelector('[data-sanm-teaser]');
    var KEY = 'sollis_anm', PV = 'sollis_anm_pv', SESS = 'sollis_anm_sitzung', NL = 'sollis_nl_done', TAG = 864e5;
    var design = d.design === '1';
    var mobil = window.matchMedia('(max-width: 749px)');
    var feinZeiger = window.matchMedia('(hover: hover) and (pointer: fine)');
    var ruhig = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var offen = false, ausloeser = 'Knopf', vorher = null, teaserDa = false, erfolgDa = false;

    function zahl(v, f) { var n = parseInt(v, 10); return isNaN(n) ? f : n; }
    function lies() { try { return JSON.parse(localStorage.getItem(KEY) || '{}') || {}; } catch (e) { return {}; } }
    var st = lies();
    function setz(k, v) {
      if (design) return;
      st = lies(); st[k] = v;
      try { localStorage.setItem(KEY, JSON.stringify(st)); } catch (e) {}
    }
    function track(ev, extra) {
      if (d.track !== '1' || design) return;
      var p = { event: ev, seite: location.pathname };
      if (extra) for (var k in extra) p[k] = extra[k];
      try { window.dataLayer = window.dataLayer || []; window.dataLayer.push(p); } catch (e) {}
    }

    /* Signale, die das automatische Anzeigen dauerhaft beenden */
    var q = null;
    try { q = new URLSearchParams(location.search); } catch (e) {}
    function para(n) { return q ? (q.get(n) || '') : ''; }
    var testmodus = para('sollis_popup').toLowerCase();
    var test = testmodus === 'zeigen' || testmodus === 'teaser';
    if (testmodus === 'reset' && !design) {
      try { localStorage.removeItem(KEY); sessionStorage.removeItem(SESS); sessionStorage.removeItem(PV); } catch (e) {}
      st = {};
    }
    if (para('_kx') || para('utm_source').toLowerCase().indexOf('klaviyo') > -1 || para('utm_medium').toLowerCase() === 'email') {
      if (!st.bekannt) setz('bekannt', Date.now());
    }
    if (d.bestaetigt === '1') setz('angemeldet', Date.now());
    try { if (localStorage.getItem(NL) && !st.angemeldet) setz('angemeldet', Date.now()); } catch (e) {}
    document.addEventListener('sollis:newsletter-signup', function () { if (!st.angemeldet) setz('angemeldet', Date.now()); teaserWeg(); });

    function klaviyoBekannt() {
      if (d.kla !== '1') return false;
      try {
        var m = document.cookie.match(/(?:^|;\s*)__kla_id=([^;]+)/);
        if (!m) return false;
        var j = JSON.parse(atob(decodeURIComponent(m[1])));
        return !!(j && (j.$exchange_id || j.$email || j.$phone_number));
      } catch (e) { return false; }
    }
    function adresseAus() {
      var p = location.pathname.toLowerCase(), a = (d.adressen || '').split('|');
      for (var i = 0; i < a.length; i++) { var x = a[i].trim().toLowerCase(); if (x && p.indexOf(x) > -1) return true; }
      return false;
    }
    function grundsaetzlichAus() { return !!(st.angemeldet || st.bekannt || klaviyoBekannt() || adresseAus()); }

    var pv = 1;
    if (!design) { try { pv = zahl(sessionStorage.getItem(PV), 0) + 1; sessionStorage.setItem(PV, String(pv)); } catch (e) {} }

    function darfAuto() {
      if (d.auto !== '1' || grundsaetzlichAus()) return false;
      var letzt = Math.max(st.zu || 0, st.gezeigt || 0);
      if (letzt && Date.now() - letzt < zahl(d.pause, 30) * TAG) return false;
      var max = zahl(d.max, 0);
      if (max > 0 && (st.anzahl || 0) >= max) return false;
      try { if (sessionStorage.getItem(SESS)) return false; } catch (e) {}
      return true;
    }
    function darfTeaser() {
      if (!teaser || d.auto !== '1' || grundsaetzlichAus()) return false;
      if (st.teaserAus && Date.now() - st.teaserAus < zahl(d.teaserAusTage, 90) * TAG) return false;
      if (mobil.matches && d.teaserMobil !== '1') return false;
      if (d.teaserModus === 'nach') return !!st.zu && Date.now() - st.zu < zahl(d.teaserTage, 7) * TAG;
      return true;
    }
    function cookieOffen() {
      if (d.cookie !== '1') return false;
      try {
        var cp = window.Shopify && window.Shopify.customerPrivacy;
        if (!cp || typeof cp.shouldShowBanner !== 'function' || !cp.shouldShowBanner()) return false;
        var c = typeof cp.currentVisitorConsent === 'function' ? cp.currentVisitorConsent() : null;
        return !!c && !c.marketing && !c.analytics && !c.preferences;
      } catch (e) { return false; }
    }
    /* Nach der Cookie-Entscheidung mindestens 3 s Abstand, damit nicht zwei Einblendungen aufeinander folgen */
    var cookieWarten = false, cookieFrei = 0;
    function cookieBereit() {
      if (cookieOffen()) { cookieWarten = true; cookieFrei = 0; return false; }
      if (!cookieWarten) return true;
      if (!cookieFrei) cookieFrei = Date.now();
      return Date.now() - cookieFrei >= 3000;
    }
    /* Mobil keine automatische Einblendung auf der Einstiegsseite aus Suchmaschinen (Google-Richtlinie) */
    function sucheEinstieg() {
      if (d.mobilSuche !== '1' || !mobil.matches || pv > 1) return false;
      return /\/\/(www\.)?(google|bing|duckduckgo|ecosia|yahoo|qwant|startpage|yandex|baidu)\./.test((document.referrer || '').toLowerCase());
    }
    /* Bei gefuelltem Warenkorb kein automatisches Popup, der Code kaeme erst nach der Bestaetigungsmail */
    function warenkorbVoll(cb) {
      if (d.warenkorbAus !== '1') { cb(false); return; }
      var url = (window.theme && window.theme.routes && window.theme.routes.cart) || '/cart.js';
      try {
        fetch(url, { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (c) { cb(!!(c && c.item_count > 0)); })
          .catch(function () { cb(false); });
      } catch (e) { cb(false); }
    }
    function beschaeftigt() {
      var k = (document.documentElement.className || '') + ' ' + ((document.body && document.body.className) || '');
      if (/js-drawer-open|modal-open|sanm-offen/.test(k)) return true;
      if (document.querySelector('.drawer.drawer--is-open, .modal.modal--is-active')) return true;
      var a = document.activeElement;
      if (a && a !== document.body && !root.contains(a) && (/^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName) || a.isContentEditable)) return true;
      return document.visibilityState === 'hidden';
    }

    /* Oeffnen und Schliessen */
    function fokusierbar() {
      return Array.prototype.filter.call(dlg.querySelectorAll('button, [href], input, select, textarea, [tabindex]'), function (el) {
        return !el.disabled && el.tabIndex !== -1 && el.offsetParent !== null;
      });
    }
    function oeffnen(quelle, manuell) {
      if (offen || !dlg) return;
      offen = true;
      ausloeser = quelle || 'Knopf';
      vorher = document.activeElement;
      formteil.hidden = erfolgDa;
      erfolg.hidden = !erfolgDa;
      root.classList.toggle('is-erfolg', erfolgDa);
      var img = dlg.querySelector('.sanm__buehne img');
      if (img) img.loading = 'eager';
      ov.hidden = false;
      dlg.hidden = false;
      var sb = window.innerWidth - document.documentElement.clientWidth;
      if (sb > 0) document.body.style.paddingRight = sb + 'px';
      document.documentElement.classList.add('sanm-offen');
      teaserWeg();
      requestAnimationFrame(function () { requestAnimationFrame(function () { root.classList.add('is-open'); }); });
      if (!erfolgDa) {
        if (pkDaten && pkDaten.art === 'produkt' && pkListe.length) produkteZeigen(pkListe);
        hochzaehlen();
        preiseAnimieren();
      }
      setTimeout(function () {
        var ziel = null;
        if (!mobil.matches && !formteil.hidden) {
          var felder = form.querySelectorAll('.sanm__in');
          for (var i = 0; i < felder.length; i++) { if (!felder[i].value && felder[i].offsetParent !== null) { ziel = felder[i]; break; } }
          if (!ziel) ziel = form.querySelector('[data-sanm-los]');
        }
        try { (ziel || dlg).focus({ preventScroll: true }); } catch (e) {}
      }, ruhig ? 0 : 80);
      if (!manuell) {
        setz('gezeigt', Date.now());
        setz('anzahl', (st.anzahl || 0) + 1);
        try { sessionStorage.setItem(SESS, '1'); } catch (e) {}
      }
      track('sollis_popup_gezeigt', { ausloeser: ausloeser });
    }
    function schliessen(art) {
      if (!offen) return;
      offen = false;
      dlg.style.transform = '';
      root.classList.remove('is-open');
      var ende = function () { if (!offen) { ov.hidden = true; dlg.hidden = true; } };
      if (ruhig) ende(); else setTimeout(ende, 260);
      document.documentElement.classList.remove('sanm-offen');
      document.body.style.paddingRight = '';
      if (!st.angemeldet) setz('zu', Date.now());
      try { if (vorher && vorher.focus && document.contains(vorher) && vorher !== document.body) vorher.focus({ preventScroll: true }); } catch (e) {}
      track('sollis_popup_geschlossen', { art: art, ausloeser: ausloeser });
      if (!design) setTimeout(function () { if (!offen && (test ? !erfolgDa : darfTeaser())) teaserZeigen(); }, 700);
    }
    function zeigeErfolg() {
      erfolgDa = true;
      root.classList.add('is-erfolg');
      formteil.hidden = true;
      erfolg.hidden = false;
      teaserWeg();
      setTimeout(function () { try { erfolg.focus({ preventScroll: true }); } catch (e) {} }, 30);
      if (d.konfetti === '1' && !design) {
        setTimeout(function () {
          try { if (offen && window.sollisBewegung && typeof window.sollisBewegung.konfetti === 'function') window.sollisBewegung.konfetti(dlg, { fest: true }); } catch (e) {}
        }, 380);
      }
    }

    /* Wert auf dem Gutschein zaehlt beim Oeffnen hoch (Solli's Bewegung, Hochzaehlen fuer Fakten) */
    function hochzaehlen() {
      var el = root.querySelector('[data-sanm-wert]');
      if (!el) return;
      var text = el.getAttribute('data-text');
      if (text === null) { text = el.textContent; el.setAttribute('data-text', text); }
      el.textContent = text;
      var sb = window.sollisBewegung;
      if (d.bewegung !== '1' || ruhig || !sb || typeof sb.zaehle !== 'function') return;
      var m = text.match(/\d+/);
      if (!m) return;
      var ziel = parseInt(m[0], 10), vor = text.slice(0, m.index), nach = text.slice(m.index + m[0].length);
      var fmt = function (v) { return vor + Math.round(v) + nach; };
      el.textContent = fmt(0);
      setTimeout(function () { sb.zaehle(el, 0, ziel, { dauer: 800, format: fmt }); }, 280);
    }

    /* Produkte mit Preis statt Gutschein. Daten aus der Sektion (Produktseite, Kollektion, Bestseller),
       auf uebrigen Seiten die zuletzt angesehenen Produkte (gleiche Liste wie die Leiste Zuletzt angesehen).
       Preis mit Code = Preis minus gerundeter Rabatt, so rechnet auch der Rabattcode pro Artikel. */
    var pkDaten = null, pkBox = root.querySelector('[data-sanm-pbox]'), pkListe = [], zlVersprechen = null, animLauf = 0;
    try { var pkEl = root.querySelector('[data-sanm-produkte]'); if (pkEl) pkDaten = JSON.parse(pkEl.textContent); } catch (e) { pkDaten = null; }
    var ZL = 'sollisRecentlyViewed', PCT = zahl(d.rabatt, 10);
    var EINHEIT = { mg: 0.001, g: 1, kg: 1000, ml: 1, cl: 10, l: 1000 };
    function zlLies() { try { var l = JSON.parse(localStorage.getItem(ZL)); return Array.isArray(l) ? l : []; } catch (e) { return []; } }
    if (!design && d.handle) {
      var zlNeu = zlLies().filter(function (h) { return h && h !== d.handle; });
      zlNeu.unshift(d.handle);
      try { localStorage.setItem(ZL, JSON.stringify(zlNeu.slice(0, 24))); } catch (e) {}
    }
    function esc(t) { return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    function mitCode(p) { return p - Math.round(p * PCT / 100); }
    function formatierer(muster) {
      muster = String(muster || '');
      var m = muster.match(/\d[\d.,'\u00a0\u202f ]*\d|\d/);
      if (!m) return function (c) { return (Math.round(c) / 100).toFixed(2); };
      var zt = m[0], vor = muster.slice(0, m.index), nach = muster.slice(m.index + zt.length);
      var dez = /[.,]\d{2}$/.test(zt) ? zt.charAt(zt.length - 3) : '';
      var rest = dez ? zt.slice(0, -3) : zt;
      var t = rest.match(/[.,'\u00a0\u202f ]/), tsd = t ? t[0] : '';
      return function (c) {
        c = Math.max(0, Math.round(c));
        var s = String(dez ? Math.floor(c / 100) : Math.round(c / 100));
        if (tsd) s = s.replace(/\B(?=(\d{3})+(?!\d))/g, tsd);
        if (dez) { var r = c % 100; s += dez + (r < 10 ? '0' : '') + r; }
        return vor + s + nach;
      };
    }
    function grundpreis(v, n, f) {
      if (!v || !v.q || !v.r || !v.qu || !v.ru) return '';
      var qu = String(v.qu).toLowerCase(), ru = String(v.ru).toLowerCase(), fq = EINHEIT[qu], fr = EINHEIT[ru];
      if (!fq || !fr || Math.abs(v.q * fq - v.r * fr) < 1e-9) return '';
      return f(Math.round(n * (v.r * fr) / (v.q * fq))) + ' / ' + (Number(v.r) === 1 ? '' : v.r + ' ') + ru;
    }
    function variante(prod) {
      var id = prod.s, v = null;
      if (pkDaten && pkDaten.art === 'produkt' && !pkDaten.bestseller) {
        var inp = document.querySelector('.product-single__form [name="id"], form[action*="/cart/add"] [name="id"]');
        if (inp && inp.value) id = parseInt(inp.value, 10);
      }
      (prod.v || []).forEach(function (x) { if (x.id === id) v = x; });
      if (!v || !v.a) { v = null; (prod.v || []).forEach(function (x) { if (!v && x.a) v = x; }); }
      return v;
    }
    function karte(prod, v) {
      var f = formatierer(v.m), n = mitCode(v.p), alt = f(v.p), neu = f(n), gp = grundpreis(v, n, f);
      var sr = String(d.srPreis || '').replace('[alt]', alt).replace('[neu]', neu);
      var bild = v.i ? '<img src="' + esc(v.i) + '" srcset="' + esc(v.i) + ' 300w, ' + esc(v.i2 || v.i) + ' 600w" sizes="(min-width: 750px) 220px, 88px" alt="" loading="lazy" decoding="async">' : '';
      return '<div class="sanm-k" data-sanm-karte data-handle="' + esc(prod.h) + '" data-von="' + v.p + '" data-bis="' + n + '">' +
        '<span class="sanm-k__img">' + bild + '<span class="sanm-k__badge" aria-hidden="true">' + esc(d.badge) + '</span></span>' +
        '<span class="sanm-k__txt"><span class="sanm-k__name">' + esc(prod.t) + '</span>' +
        '<span class="sanm-k__preise">' + (d.preisAlt === '1' ? '<s class="sanm-k__alt" aria-hidden="true">' + esc(alt) + '</s>' : '') +
        '<span class="sanm-k__neu h3" data-sanm-kneu aria-hidden="true" data-ende="' + esc(neu) + '">' + esc(neu) + '</span>' +
        '<span class="sanm-k__badge sanm-k__badge--zeile" aria-hidden="true">' + esc(d.badge) + '</span>' +
        '<span class="visually-hidden">' + esc(sr) + '</span></span>' +
        (gp ? '<small class="sanm-k__gp">' + esc(gp) + '</small>' : '') + '</span></div>';
    }
    function produkteZeigen(liste) {
      if (!pkBox || !liste || !liste.length) return false;
      var html = '', n = 0;
      liste.forEach(function (prod) {
        if (n >= 2 || !prod || !prod.v) return;
        var v = variante(prod);
        if (!v) return;
        html += karte(prod, v);
        n++;
      });
      if (!n) return false;
      pkListe = liste;
      pkBox.innerHTML = html;
      dlg.classList.add('sanm--produkte');
      dlg.classList.toggle('sanm--zwei', n > 1);
      return true;
    }
    function zuletztLaden() {
      if (zlVersprechen) return zlVersprechen;
      if (d.zuletzt !== '1' || !pkDaten || pkDaten.art !== 'sonst' || !pkBox || typeof fetch !== 'function') return null;
      var hs = zlLies().filter(function (h) { return h && typeof h === 'string'; }).slice(0, 4);
      if (!hs.length) return null;
      var url = (d.suche || '/search') + '?view=sollis-anmeldung&type=product&q=' + encodeURIComponent(hs.map(function (h) { return 'handle:' + h; }).join(' OR '));
      try {
        zlVersprechen = fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (t) {
          var l = JSON.parse(String(t).trim());
          if (!Array.isArray(l) || !l.length || offen) return;
          l.sort(function (a, b) { return hs.indexOf(a.h) - hs.indexOf(b.h); });
          produkteZeigen(l);
        }).catch(function () {});
      } catch (e) { zlVersprechen = null; }
      return zlVersprechen;
    }
    function zaehlen(el, von, bis, f, ende, dauer, lauf, fertig) {
      var t0 = 0;
      function schritt(t) {
        if (lauf !== animLauf) return;
        if (!t0) t0 = t;
        var q = Math.min(1, (t - t0) / dauer), e = 1 - Math.pow(1 - q, 3);
        el.textContent = q < 1 ? f(von + (bis - von) * e) : ende;
        if (q < 1) requestAnimationFrame(schritt); else if (fertig) fertig();
      }
      requestAnimationFrame(schritt);
    }
    function preiseAnimieren() {
      var ks = pkBox ? pkBox.querySelectorAll('[data-sanm-karte]') : [];
      if (!ks.length) return;
      var lauf = ++animLauf, bewegt = d.bewegung === '1' && !ruhig;
      Array.prototype.forEach.call(ks, function (k, i) {
        var el = k.querySelector('[data-sanm-kneu]');
        if (!el) return;
        var von = parseInt(k.getAttribute('data-von'), 10), bis = parseInt(k.getAttribute('data-bis'), 10), ende = el.getAttribute('data-ende') || el.textContent;
        k.classList.remove('is-vor', 'is-zaehlt');
        el.textContent = ende;
        if (!bewegt || isNaN(von) || isNaN(bis) || von === bis) return;
        var f = formatierer(ende);
        k.classList.add('is-vor');
        el.textContent = f(von);
        setTimeout(function () {
          if (lauf !== animLauf) return;
          k.classList.remove('is-vor');
          k.classList.add('is-zaehlt');
          zaehlen(el, von, bis, f, ende, 900, lauf, function () { k.classList.remove('is-zaehlt'); });
        }, 1000 + i * 220);
      });
    }
    if (pkDaten && pkDaten.liste) produkteZeigen(pkDaten.liste);

    /* Teaser */
    function fixiert(el) {
      while (el && el !== document.body && el !== document.documentElement) {
        var p = window.getComputedStyle(el).position;
        if (p === 'fixed' || p === 'sticky') return el;
        el = el.parentElement;
      }
      return null;
    }
    function platzieren() {
      if (!teaser || teaser.hidden || !document.elementsFromPoint) return;
      var basis = zahl(d.teaserUnten, 20);
      teaser.style.bottom = basis + 'px';
      var r = teaser.getBoundingClientRect();
      if (!r.width) return;
      var vh = window.innerHeight, hoch = 0;
      [[r.left + 6, r.top + r.height / 2], [r.right - 6, r.top + r.height / 2], [r.left + r.width / 2, r.top + 3], [r.left + r.width / 2, r.bottom - 3]].forEach(function (pt) {
        if (pt[0] < 0 || pt[1] < 0 || pt[0] >= window.innerWidth || pt[1] >= vh) return;
        var els = document.elementsFromPoint(pt[0], pt[1]);
        for (var i = 0; i < els.length; i++) {
          if (root.contains(els[i])) continue;
          var f = fixiert(els[i]);
          if (!f || root.contains(f)) continue;
          var fr = f.getBoundingClientRect();
          if (fr.height > vh * 0.6) continue;
          hoch = Math.max(hoch, vh - fr.top + 12);
        }
      });
      if (hoch > basis) teaser.style.bottom = Math.round(hoch) + 'px';
    }
    function teaserZeigen() {
      if (!teaser || teaserDa || offen) return;
      teaserDa = true;
      teaser.hidden = false;
      platzieren();
      requestAnimationFrame(function () { teaser.classList.add('is-in'); });
      setTimeout(platzieren, 1500);
      track('sollis_teaser_gezeigt', {});
    }
    function teaserStart() {
      var n = 0;
      (function pruef() {
        if (offen || teaserDa || !darfTeaser()) return;
        if (cookieOffen() || beschaeftigt()) { if (++n <= 120) setTimeout(pruef, 1000); return; }
        teaserZeigen();
      })();
    }
    function teaserWeg() {
      if (!teaser || !teaserDa) return;
      teaserDa = false;
      teaser.classList.remove('is-in');
      setTimeout(function () { if (!teaserDa) teaser.hidden = true; }, ruhig ? 0 : 300);
    }
    var platzUhr = null;
    window.addEventListener('resize', function () { clearTimeout(platzUhr); platzUhr = setTimeout(platzieren, 200); });

    /* Klicks im Popup und am Teaser */
    root.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var zu = t.closest('[data-sanm-zu]');
      if (zu) { e.preventDefault(); schliessen(zu.getAttribute('data-sanm-zu')); return; }
      var auf = t.closest('[data-sanm-auf]');
      if (auf) { e.preventDefault(); track('sollis_teaser_klick', {}); oeffnen(auf.getAttribute('data-sanm-auf'), true); return; }
      if (t.closest('[data-sanm-teaser-aus]')) { e.preventDefault(); setz('teaserAus', Date.now()); teaserWeg(); track('sollis_teaser_aus', {}); }
    });
    document.addEventListener('keydown', function (e) {
      if (!offen) return;
      if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); schliessen('esc'); return; }
      if (e.key !== 'Tab') return;
      var f = fokusierbar();
      if (!f.length) return;
      var erst = f[0], letzt = f[f.length - 1], akt = document.activeElement;
      if (!dlg.contains(akt)) { e.preventDefault(); erst.focus(); return; }
      if (e.shiftKey && (akt === erst || akt === dlg)) { e.preventDefault(); letzt.focus(); }
      else if (!e.shiftKey && akt === letzt) { e.preventDefault(); erst.focus(); }
    });

    /* Mobil: nach unten wischen schliesst */
    var y0 = null, dy = 0;
    dlg.addEventListener('touchstart', function (e) {
      y0 = null;
      if (!mobil.matches || dlg.scrollTop > 0 || !e.touches.length) return;
      if (e.target.closest && e.target.closest('input, label, button, a, textarea, select')) return;
      y0 = e.touches[0].clientY; dy = 0;
    }, { passive: true });
    dlg.addEventListener('touchmove', function (e) {
      if (y0 === null || !e.touches.length) return;
      dy = e.touches[0].clientY - y0;
      if (dy > 0) { dlg.style.transition = 'none'; dlg.style.transform = 'translateY(' + dy + 'px)'; }
    }, { passive: true });
    dlg.addEventListener('touchend', function () {
      if (y0 === null) return;
      y0 = null;
      dlg.style.transition = '';
      dlg.style.transform = '';
      if (dy > 90) schliessen('wischen');
    });

    /* Anmeldung ueber die Klaviyo-Client-API */
    function meldung(text, feld) {
      if (!msg) return;
      Array.prototype.forEach.call(form.querySelectorAll('.is-err'), function (x) { x.classList.remove('is-err'); });
      Array.prototype.forEach.call(form.querySelectorAll('[aria-invalid]'), function (x) { x.removeAttribute('aria-invalid'); });
      if (!text) { msg.hidden = true; msg.textContent = ''; return; }
      msg.textContent = text;
      msg.hidden = false;
      if (feld) {
        (feld.closest('.sanm__box') || feld).classList.add('is-err');
        feld.setAttribute('aria-invalid', 'true');
        try { feld.focus(); } catch (e) {}
      }
    }
    function quizDaten(props) {
      try {
        var qz = JSON.parse(localStorage.getItem('sollis_quiz_result') || 'null');
        if (!qz) return;
        if (qz.name) props['Tiername'] = String(qz.name).trim();
        if (qz.themen && qz.themen.length) {
          props['Quiz Themen'] = qz.themen.filter(function (t) { return t && (t.score > 0 || t.prevent); }).map(function (t) { return t.label || t.t; }).slice(0, 8);
        }
        if (qz.breed) props['Rasse'] = qz.breed;
        if (qz.age) props['Alter'] = qz.age;
        if (qz.size) props['Groesse'] = qz.size;
      } catch (e) {}
    }
    function senden(attrs, quelle) {
      var revs = [];
      [d.rev, '2026-07-15', '2025-07-15', '2024-10-15'].forEach(function (r) { if (r && revs.indexOf(r) < 0) revs.push(r); });
      var url = 'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(d.company);
      function inhalt(a) {
        return JSON.stringify({ data: { type: 'subscription', attributes: { custom_source: quelle, profile: { data: { type: 'profile', attributes: a } } }, relationships: { list: { data: { type: 'list', id: d.list } } } } });
      }
      function versuch(i, a, knapp) {
        return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'revision': revs[i] }, body: inhalt(a) }).then(function (r) {
          if (r.ok || r.status === 202) return true;
          return r.text().then(function (t) {
            var low = String(t || '').toLowerCase(), weiter = i + 1 < revs.length;
            if (low.indexOf('revision') > -1 && weiter) return versuch(i + 1, attrs, false);
            if (r.status === 400 && !knapp) return versuch(i, { email: a.email, subscriptions: a.subscriptions }, true);
            if (r.status === 400 && weiter) return versuch(i + 1, attrs, false);
            throw new Error('Klaviyo ' + r.status);
          });
        });
      }
      return versuch(0, attrs, false);
    }
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (design) { zeigeErfolg(); return; }
        var hp = form.querySelector('[data-sanm-hp]');
        if (hp && hp.value) { zeigeErfolg(); return; }
        var em = form.querySelector('input[name="email"]'), vn = form.querySelector('input[name="vorname"]'), box = form.querySelector('[data-sanm-box]');
        var mail = ((em && em.value) || '').trim();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(mail)) { meldung(d.errMail, em); return; }
        if (box && !box.checked) { meldung(d.errBox, box); return; }
        if (!d.company || !d.list) { meldung(d.errGen); return; }
        meldung('');
        var props = { 'Quelle': d.quelle, 'Popup Ausloeser': ausloeser, 'Anmeldung URL': location.href.split('?')[0], 'Sprache': d.sprache };
        var tier = form.querySelector('input[name="sanm-tier"]:checked');
        if (tier) props['Tierart'] = tier.value;
        quizDaten(props);
        var attrs = { email: mail, properties: props, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } };
        var name = vn && vn.value ? vn.value.trim() : '';
        if (name) attrs.first_name = name;
        var btn = form.querySelector('[data-sanm-los]');
        btn.disabled = true;
        btn.classList.add('is-busy');
        senden(attrs, d.quelle + ' (' + ausloeser + ')').then(function () {
          setz('angemeldet', Date.now());
          try { localStorage.setItem(NL, String(Date.now())); } catch (x) {}
          try {
            if (window.klaviyo && typeof window.klaviyo.identify === 'function') window.klaviyo.identify({ email: mail });
            else { window._learnq = window._learnq || []; window._learnq.push(['identify', { $email: mail }]); }
          } catch (x) {}
          try { document.dispatchEvent(new CustomEvent('sollis:newsletter-signup', { detail: { email: mail, quelle: 'Popup' } })); } catch (x) {}
          track('sollis_newsletter_anmeldung', { quelle: 'Popup', ausloeser: ausloeser });
          try { if (typeof window.fbq === 'function') window.fbq('track', 'Lead', { content_name: 'Newsletter Popup' }); } catch (x) {}
          zeigeErfolg();
        }).catch(function () {
          meldung(d.errGen);
        }).then(function () {
          btn.disabled = false;
          btn.classList.remove('is-busy');
        });
      });
      form.addEventListener('input', function (e) { if (e.target && e.target.getAttribute('aria-invalid')) meldung(''); });
      form.addEventListener('change', function (e) { if (e.target && e.target.getAttribute('aria-invalid')) meldung(''); });
    }

    /* Knoepfe, die bisher ein Klaviyo-Formular oeffneten, und Links auf #newsletter */
    var fs = (d.formulare || '').split(/[\s,]+/);
    var alle = fs.some(function (x) { return x.toLowerCase() === 'alle'; });
    var ids = fs.filter(function (x) { return x && x.toLowerCase() !== 'alle'; });
    function formIdVon(el) {
      var id = el.getAttribute('data-kl-form') || '';
      if (!id) { var h = el.closest('[data-kl-form], [data-form-id]'); if (h) id = h.getAttribute('data-kl-form') || h.getAttribute('data-form-id') || ''; }
      if (!id) { var m = (el.getAttribute('onclick') || '').match(/openForm['"]?\s*,\s*['"]([A-Za-z0-9]+)['"]/); if (m) id = m[1]; }
      return id;
    }
    if (!design) {
      document.addEventListener('click', function (e) {
        var t = e.target;
        if (!t || !t.closest) return;
        var el = t.closest('[data-sollis-anmeldung], a[href$="#newsletter"], a[href$="#anmeldung"]');
        if (!el) {
          var k = t.closest('.rb-news__btn, [data-nls-open], button.sollis-nl, [onclick*="openForm"]');
          if (k) { var id = formIdVon(k); if (alle || (id && ids.indexOf(id) > -1)) el = k; }
        }
        if (!el) return;
        e.preventDefault();
        e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();
        oeffnen('Knopf', true);
      }, true);
    }
    window.SollisAnmeldung = {
      oeffnen: function (quelle) { oeffnen(quelle || 'Knopf', true); },
      schliessen: function () { schliessen('api'); }
    };

    /* Ausloeser */
    function starte() {
      if (design) return;
      if (testmodus === 'zeigen') {
        var testAuf = false, testLos = function () { if (!testAuf) { testAuf = true; oeffnen('Test', true); } };
        var zlTest = zuletztLaden();
        if (zlTest) zlTest.then(function () { setTimeout(testLos, 200); });
        setTimeout(testLos, zlTest ? 2000 : 400);
        return;
      }
      if (testmodus === 'teaser') { setTimeout(teaserZeigen, 400); return; }
      if (location.hash === '#newsletter' || location.hash === '#anmeldung') { setTimeout(function () { oeffnen('Link', true); }, 600); return; }
      if (darfTeaser()) setTimeout(teaserStart, 2500);
      if (darfAuto() || darfTeaser()) setTimeout(zuletztLaden, 1500);
      if (!darfAuto() || sucheEinstieg()) return;
      var start = Date.now(), sekMs = zahl(d.sek, 8) * 1000, fertig = false, versuche = 0;
      var img = dlg.querySelector('.sanm__buehne img');
      if (img && !mobil.matches) setTimeout(function () { img.loading = 'eager'; }, Math.max(1500, sekMs - 2000));
      function los(quelle) {
        if (fertig || offen) return;
        if (!cookieBereit() || beschaeftigt()) {
          if (++versuche <= 120) setTimeout(function () { los(quelle); }, 1000);
          return;
        }
        fertig = true;
        if (!darfAuto()) return;
        warenkorbVoll(function (voll) {
          if (voll) { track('sollis_popup_unterdrueckt', { grund: 'Warenkorb', ausloeser: quelle }); return; }
          if (!offen) oeffnen(quelle, false);
        });
      }
      if (d.seitentyp === 'article') {
        var zielA = zahl(d.blogScroll, 70) / 100;
        var koerper = document.querySelector('[itemprop="articleBody"], .article__body, article .rte, article');
        var pruefA = function () {
          if (fertig) { window.removeEventListener('scroll', pruefA); return; }
          if (Date.now() - start < sekMs) return;
          var anteil;
          if (koerper) {
            var rk = koerper.getBoundingClientRect();
            anteil = (window.innerHeight - rk.top) / Math.max(rk.height, 1);
          } else {
            var de = document.documentElement;
            anteil = ((window.pageYOffset || de.scrollTop) + window.innerHeight) / Math.max(de.scrollHeight, 1);
          }
          if (anteil >= zielA) { window.removeEventListener('scroll', pruefA); los('Artikel'); }
        };
        window.addEventListener('scroll', pruefA, { passive: true });
        setTimeout(pruefA, sekMs + 50);
      } else if (d.produkt !== 'nur_exit') {
        if (pv >= zahl(d.seite, 2)) {
          setTimeout(function () { los('Seitenaufruf'); }, sekMs);
        } else if (zahl(d.scroll, 0) > 0) {
          var ziel = zahl(d.scroll, 50) / 100;
          var pruef = function () {
            if (fertig) { window.removeEventListener('scroll', pruef); return; }
            if (Date.now() - start < sekMs) return;
            var h = document.documentElement;
            var anteil = ((window.pageYOffset || h.scrollTop) + window.innerHeight) / Math.max(h.scrollHeight, 1);
            if (anteil >= ziel) { window.removeEventListener('scroll', pruef); los('Scrolltiefe'); }
          };
          window.addEventListener('scroll', pruef, { passive: true });
          setTimeout(pruef, sekMs + 50);
        }
      }
      if (d.exit === '1' && feinZeiger.matches && !mobil.matches) {
        var raus = function (e) {
          if (fertig) { document.removeEventListener('mouseout', raus); return; }
          if (e.relatedTarget || e.clientY > 8 || Date.now() - start < 5000) return;
          document.removeEventListener('mouseout', raus);
          los('Verlassen');
        };
        document.addEventListener('mouseout', raus);
      }
    }

    /* Vorschau im Theme-Editor */
    if (design) {
      if (d.editor === 'popup') oeffnen('Editor', true);
      else if (d.editor === 'erfolg') { oeffnen('Editor', true); zeigeErfolg(); }
      else if (d.editor === 'teaser') teaserZeigen();
      document.addEventListener('shopify:section:select', function (e) {
        if (!e.detail || e.detail.sectionId !== d.sid || !document.contains(root)) return;
        if (d.editor === 'teaser') teaserZeigen(); else oeffnen('Editor', true);
      });
      document.addEventListener('shopify:section:deselect', function (e) {
        if (!e.detail || e.detail.sectionId !== d.sid || !document.contains(root)) return;
        schliessen('editor');
        teaserWeg();
      });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', starte); else starte();
  }
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('#sanm')) init();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
